import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip';

export default function IconTooltip({ label, children, side = 'top', sideOffset = 8 }) {
  const [showLabel, setShowLabel] = useState(false);
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => clearTimeout(timerRef.current), []);
  useEffect(() => () => clearTimer(), [clearTimer]);

  const onTouchStart = useCallback(() => {
    clearTimer();
    timerRef.current = setTimeout(() => setShowLabel(true), 400);
  }, [clearTimer]);

  const onTouchEnd = useCallback(() => {
    clearTimer();
    setTimeout(() => setShowLabel(false), showLabel ? 1200 : 0);
  }, [showLabel, clearTimer]);

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="relative inline-flex"
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            onTouchCancel={() => { clearTimer(); setShowLabel(false); }}
            onContextMenu={(e) => showLabel && e.preventDefault()}
          >
            {children}
            {showLabel && (
              <span
                className={`absolute left-1/2 -translate-x-1/2 z-[100] pointer-events-none animate-in fade-in zoom-in-95 duration-150 ${side === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'}`}
                style={{ whiteSpace: 'nowrap' }}
              >
                <span className="block rounded-lg px-3 py-1.5 text-xs font-medium bg-popover text-popover-foreground border border-border shadow-lg">
                  {label}
                </span>
              </span>
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset} className="hidden md:block rounded-xl px-3 py-1.5 text-xs font-medium bg-popover text-popover-foreground border border-border shadow-lg">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
